/* eslint-disable import/extensions */
import { ICC_REGEX, REQUIRED_FIELD_ERROR, FIELD_INVALID } from '@masfront/common-b2c'
import { string } from 'yup'

import { SAME_ICC } from '../../constants/errors'

import { SignUpType, PortabilityType } from '~/basket/model/lines/signup.model'

const iccSchemas = (isOffline: boolean) => ({
  donorICC: string()
    .label('ICC')
    .test('equal-icc', SAME_ICC, function (val) {
      if (!isOffline) return true
      const { icc } = this.parent
      return val !== icc
    })
    .when(['portabilityType', 'signUpType'], {
      is: (portabilityType, signUpType) =>
        portabilityType === PortabilityType.PREPAID && signUpType === SignUpType.PORTABILITY,
      then: string().matches(ICC_REGEX, FIELD_INVALID).required(REQUIRED_FIELD_ERROR),
      otherwise: string(),
    }),
})

export default iccSchemas
